// ink-component
import React, { ReactNode, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import HStack from '../HStack/HStack';
import { MobileControlWrapper } from './styles';

import { injectInputComponents } from '../../helpers';
import useWindowWidth from '../../hooks/useWindowWidth';

export interface ListControlProps {
  /** Contents */
  children?: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

/**
 * @purpose Allows you to add inputs to the far right of ListItem, and below on mobile
 * @categories layout
 * @group List
 */
function ListControl(props: ListControlProps) {
  const { isMobile } = useWindowWidth();
  const themeContext = useContext(ThemeContext);

  // TODO: this injection eventually can be removed when we fix inline controls
  function renderChildren() {
    return injectInputComponents(props.children, {
      isInline: true,
    });
  }

  if (props.children) {
    return themeContext && themeContext.listItemMobile && isMobile ? (
      <MobileControlWrapper data-testid={props['data-testid']}>{renderChildren()}</MobileControlWrapper>
    ) : (
      <HStack spacing="medium" align="right" data-testid={props['data-testid']}>
        {renderChildren()}
      </HStack>
    );
  }

  return null;
}

ListControl.defaultProps = {
  children: undefined,
  'data-testid': undefined,
};

ListControl.displayName = 'ListControl';

export default ListControl;
